<template>
  <div class="pd20x flex1">
    <div class="contentBox h100pct ofA">
      <div class="filter" style="padding:10px 20px">
        <div>
          <a-button type="primary" @click="$router.push('/analysis/majorManagement')">新增专业</a-button>
          <a-button class="ml10px" @click="$router.push('/analysis/provincePolicy')">省份政策配置</a-button>
          <a-button class="ml10px" @click="$router.push('/analysis/subjectApply')">申请添加专业</a-button>
        </div>
        <div>
          <label>搜索：</label>
          <a-select v-model="selectVal" style="width: 120px; margin-right: 10px">
            <a-select-option value="name">专业名称</a-select-option>
            <a-select-option value="code">专业代码</a-select-option>
            <a-select-option value="university">大学名称</a-select-option>
          </a-select>
          <a-input-search 
            placeholder="请输入搜索内容" 
            v-model="searchInput" 
            style="width: 300px" 
            @search="onSearch" 
            class="mr10px"
          />
        </div>
      </div>
      <a-table
        :columns="columns"
        :data-source="data"
        :rowKey="'id'"
        :pagination="{pageSize: page.pageSize, total}"
        @change="changePage"
      >
        <template slot="status" slot-scope="text, record">
          <a-switch 
            :checked="text === 1" 
            @change="(checked) => handleStatusChange(checked, record)"
          />
        </template>
        <template slot="operation" slot-scope="text, record">
          <a-space>
            <a @click="() => editItem(record)">编辑</a>
            <a-popconfirm
              title="确定要删除这条记录吗?"
              @confirm="() => deleteItem(record.id)"
              ok-text="确定"
              cancel-text="取消"
            >
              <a href="#">删除</a>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </div>

    <!-- 新增/编辑弹窗 -->
    <a-modal
      :title="modalTitle"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      width="600px"
    >
      <a-form-model 
        ref="ruleForm" 
        :model="form" 
        :rules="rules" 
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item label="所属大学" prop="universityId">
          <a-select
            v-model="form.universityId"
            placeholder="请搜索并选择大学"
            show-search
            :filter-option="false"
            :show-arrow="false"
            :not-found-content="null"
            :disabled="isEdit"
            @search="handleUniversitySearch"
          >
            <a-select-option v-for="item in filteredUniversityList" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="专业名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入专业名称" />
        </a-form-model-item>
        <a-form-model-item label="专业代码" prop="code">
          <a-input v-model="form.code" placeholder="请输入专业代码" />
        </a-form-model-item>
        <a-form-model-item label="状态" prop="status">
          <a-switch 
            v-model="form.status" 
            :checked-children="'启用'" 
            :un-checked-children="'禁用'"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 关联科目弹窗 -->
    <a-modal
      title="关联科目"
      :visible="linkSubjectVisible"
      :confirm-loading="linkSubjectLoading"
      @ok="linkSubjectVisible = false"
      @cancel="linkSubjectVisible = false"
      width="800px"
    >
      <div style="margin-bottom: 16px">
        <a-input-search
          v-model="subjectSearch"
          placeholder="搜索科目"
          style="width: 200px; margin-right: 8px"
          @search="onSubjectSearch"
        />
      </div>
      
      <a-table
        :columns="subjectColumns"
        :data-source="subjectList"
        :rowKey="'id'"
        :pagination="subjectPagination"
        :row-selection="{ selectedRowKeys: selectedSubjectIds, onChange: onSelectChange }"
        @change="handleSubjectTableChange"
      >
        <template slot="operation" slot-scope="text, record">
          <a-space>
            <a v-if="record.is_linked" @click="() => unlinkSubject(record.id)">取消关联</a>
            <a v-else @click="() => linkSubjectItem(record.id)">关联</a>
          </a-space>
        </template>
      </a-table>
    </a-modal>

  </div>
</template>

<script>
const columns = [
  { title: '省份', dataIndex: 'province_name', align: 'center', width: '120px' },
  { title: '学历', dataIndex: 'education', align: 'center', width: '100px' },
  { title: '专业名称', dataIndex: 'name', align: 'center' },
  { title: '专业代码', dataIndex: 'code', align: 'center' },
  { 
    title: '状态', 
    dataIndex: 'status', 
    align: 'center',
    scopedSlots: { customRender: 'status' } 
  },
  { 
    title: '创建时间', 
    dataIndex: 'create_time', 
    align: 'center',
    customRender: text => text || '-' 
  },
  { 
    title: '操作', 
    dataIndex: 'operation', 
    align: 'center',
    width: '250px',
    scopedSlots: { customRender: 'operation' } 
  },
];

const subjectColumns = [
  { title: '科目名称', dataIndex: 'name', align: 'center' },
  { title: '科目代码', dataIndex: 'code', align: 'center' },
  { title: '创建时间', dataIndex: 'create_time', align: 'center' },
  { 
    title: '状态', 
    dataIndex: 'is_linked', 
    align: 'center',
    customRender: (text) => text ? '已关联' : '未关联'
  },
  { 
    title: '操作', 
    dataIndex: 'operation', 
    align: 'center',
    scopedSlots: { customRender: 'operation' } 
  },
];

import * as http from '@/libs/analysis'

export default {
  name: 'majorList',
  data() {
    return {
      data: [],
      columns,
      subjectColumns,
      searchInput: '',
      subjectSearch: '',
      selectVal: 'name',
      visible: false,
      linkSubjectVisible: false,
      linkSubjectLoading: false,
      confirmLoading: false,
      isEdit: false,
      currentId: null,
      currentMajor: null,
      universityId: null,
      universitySearchText: '', // 添加大学搜索文本
      universityList: [
        { id: 1, name: '清华大学', code: '1001' },
        { id: 2, name: '北京大学', code: '1002' },
      ],
      form: {
        universityId: null,
        name: '',
        code: '',
        status: true,
      },
      rules: {
        universityId: [{ required: true, message: '请选择所属大学', trigger: 'change' }],
        name: [{ required: true, message: '请输入专业名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入专业代码', trigger: 'blur' }],
      },
      page: {
        pageSize: 15,
        page: 1
      },
      total: 0,
      filter: {},
      
      // 关联科目相关
      subjectList: [],
      selectedSubjectIds: [],
      subjectPagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      }
    }
  },
  computed: {
    modalTitle() {
      return this.isEdit ? '编辑专业' : '新增专业';
    },
    // 过滤后的大学列表
    filteredUniversityList() {
      if (!this.universitySearchText) {
        return this.universityList;
      }
      const searchText = this.universitySearchText.toLowerCase();
      return this.universityList.filter(
        item => item.name.toLowerCase().includes(searchText) || 
                (item.code && item.code.toString().includes(searchText))
      );
    }
  },
  mounted() {
    this.getData();
    // 获取大学列表
    this.getUniversityList();
  },
  methods: {
    async getData() {
      try {
        const params = {
          page: this.page.page,
          pageSize: this.page.pageSize,
          keyword: this.searchInput || '',
          searchType: this.selectVal
        };
        
        const res = await http.getSchoolMajor(params);
        console.log(res)
        this.data = res.list || [];
        this.total = res.total || 0;
      } catch (error) {
        console.error('获取专业列表失败:', error);
      }
    },
    
    async getUniversityList(keyword = '') {
      try {
        const res = await http.getUniversityList({
          page: 1,
          pageSize: 100,
          keyword: keyword
        });
        this.universityList = res.list || [];
      } catch (error) {
        console.error('获取大学列表失败:', error);
      }
    },
    

    
    changePage(pagination) {
      this.page.page = pagination.current;
      this.getData();
    },
    
    showModal() {
      this.isEdit = false;
      this.form = {
        universityId: '',
        name: '',
        code: '',
        status: true,
      };
      this.visible = true;
    },
    
    editItem(record) {
      this.$router.push({
        path: '/analysis/majorManagement',
        query: { 
          id: record.id,
          name: record.name,
          code: record.code,
          province: record.province,
          education: record.education,
          status: record.status,
          universityId: record.universityId,
          credits: record.credits
        }
      });
    },
    
    async handleOk() {
      try {
        this.$refs.ruleForm.validate(async (valid) => {
          if (!valid) return;
          
          this.confirmLoading = true;
          
          const formData = {
            ...this.form,
            status: this.form.status ? 1 : 0
          };
          
          let res;
          if (this.isEdit) {
            formData.id = this.currentId;
          }

          res = await http.addSchoolMajor(formData);
          if (res.code === 1) {
            this.$message.success(this.isEdit ? '更新成功' : '添加成功');
            this.visible = false;
            this.getData();
          } else {
            this.$message.error(res.msg || (this.isEdit ? '更新失败' : '添加失败'));
          }
        });
      } catch (error) {
        console.error('操作失败:', error);
        this.$message.error(this.isEdit ? '更新失败' : '添加失败');
      } finally {
        this.confirmLoading = false;
      }
    },
    
    handleCancel() {
      this.visible = false;
      this.$refs.ruleForm.resetFields();
    },
    
    async deleteItem(id) {
      try {
        const res = await http.delSchoolMajor({ id });
        if (res.code === 1) {
          this.$message.success('删除成功');
          this.getData();
        } else {
          this.$message.error(res.msg || '删除失败');
        }
      } catch (error) {
        console.error('删除失败:', error);
        this.$message.error('删除失败');
      }
    },
    
    async handleStatusChange(checked, record) {
      const status = checked ? 1 : 0;
      try {
        const res = await http.updateSchoolMajorStatus({ id: record.id, status });
        if (res.code === 1) {
          this.$message.success('状态更新成功');
          record.status = status;
        } else {
          this.$message.error(res.msg || '状态更新失败');
        }
      } catch (error) {
        console.error('状态更新失败:', error);
        this.$message.error('状态更新失败');
      }
      // 模拟成功
      record.status = status;
      this.$message.success('状态更新成功');
    },
    
    // 处理大学选择变化
    // 处理大学搜索输入
    handleUniversitySearch(value) {
      this.universitySearchText = value;
      this.getUniversityList(value);
    },
    
    // 处理搜索
    onSearch() {
      this.page.page = 1;
      this.getData();
    },
    
    // 关联科目相关方法
    linkSubject(record) {
      this.currentMajor = record;
      this.linkSubjectVisible = true;
      this.getSubjectList();
    },
    
    // 关联单个科目
    linkSubjectItem(subjectId) {
      if (!this.currentMajor) return;
      
      http.linkSubjectToMajor({
        majorId: this.currentMajor.id,
        subjectId: subjectId
      }).then(res => {
        console.log(res)
        this.$message.success('关联成功');
        this.getSubjectList();
      })
    },
    
    getSubjectList() {
      if (!this.currentMajor) return;
      
      const params = {
        majorId: this.currentMajor.id,
        page: this.subjectPagination.current,
        pageSize: this.subjectPagination.pageSize,
        name: this.subjectSearch || undefined
      };
      
      http.getOpenCourseList(params).then(res => {
        this.subjectList = res.list || [];
        this.subjectPagination.total = res.total || 0;
        this.selectedSubjectIds = this.subjectList.map(item => item.id);
      });
      
      // this.subjectList = [
      //   { id: 1, name: '数据结构', code: 'CS101', createTime: '2023-01-01' },
      //   { id: 2, name: '操作系统', code: 'CS102', createTime: '2023-01-02' },
      // ];
      // this.subjectPagination.total = this.subjectList.length;
      // this.selectedSubjectIds = this.subjectList.map(item => item.id);
    },
    
    onSelectChange(selectedRowKeys) {
      this.selectedSubjectIds = selectedRowKeys;
    },
    
    handleSubjectTableChange(pagination) {
      this.subjectPagination.current = pagination.current;
      this.getSubjectList();
    },
    
    onSubjectSearch() {
      this.subjectPagination.current = 1;
      this.getSubjectList();
    },
    
    async unlinkSubject(subjectId) {
      const res = await http.unlinkSubjectFromMajor({
        majorId: this.currentMajor.id,
        subjectId
      });
      this.$message.success('取消关联成功');
      this.getSubjectList();
    }

  }
}
</script>

<style scoped>
.filter {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.ml10px {
  margin-left: 10px;
}
.mr10px {
  margin-right: 10px;
}
</style>
